import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  getCurrentUserAsync,
  clearCurrentUser,
  updateCurrentUserAsync,
} from "./actions";
import { CurrentUserState } from "./slice";

type Reducer = (builder: ActionReducerMapBuilder<CurrentUserState>) => void;

export const getCurrentUserReducer: Reducer = (builder) => {
  builder.addCase(getCurrentUserAsync.fulfilled, (state, action) => {
    state.isLoading = false;
    state.isAuthorized = Boolean(action.payload);
    state.currentUser = action.payload;
  });

  builder.addCase(getCurrentUserAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(getCurrentUserAsync.rejected, (state) => {
    state.isLoading = false;
    state.isAuthorized = false;
    state.currentUser = undefined;
  });
};

export const clearCurrentUserReducer: Reducer = (builder) => {
  builder.addCase(clearCurrentUser, (state) => {
    state.isLoading = false;
    state.isAuthorized = false;
    state.currentUser = null;
  });
};

export const updateCurrentUserReducer: Reducer = (builder) => {
  builder.addCase(updateCurrentUserAsync.fulfilled, (state, action) => {
    state.isLoadingUpdate = false;
    state.currentUser = action.payload;
  });

  builder.addCase(updateCurrentUserAsync.pending, (state) => {
    state.isLoadingUpdate = true;
  });

  builder.addCase(updateCurrentUserAsync.rejected, (state) => {
    state.isLoadingUpdate = false;
  });
};
